(function () {
  function initSearchFilters(root) {
    const section = root.matches('[data-main-search]') ? root : root.querySelector('[data-main-search]');
    if (!section) return;

    const filters = section.querySelector('[data-search-filters]');
    if (!filters || filters.dataset.bound === 'true') return;

    filters.dataset.bound = 'true';

    const filterButtons = filters.querySelectorAll('[data-search-filter]');

    function setActive(target) {
      filterButtons.forEach((button) => {
        button.classList.toggle('is-active', button === target);
      });
    }

    filterButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const href = button.getAttribute('href');
        if (!href || !href.startsWith('#')) return;

        event.preventDefault();
        const target = document.querySelector(href);
        if (!target) return;

        setActive(button);
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', href);
      });
    });

    const hash = window.location.hash;
    if (hash) {
      const matching = filters.querySelector(`[href="${hash}"]`);
      if (matching) setActive(matching);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-main-search]').forEach(initSearchFilters);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initSearchFilters(event.target);
  });
})();
